var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-interim-profile"},[_c('SKHeader',{attrs:{"backTitle":this.$route.meta.prev.title(),"rootRoute":this.$route.meta.prev.name,"title":_vm.title,"dark":!_vm.$store.getters.darkmode}}),_c('SKHero'),_c('SKRouterView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }